import React from 'react';
import { ResponsiveContainer } from 'recharts';
import { Card, CardBody, Col, Button, Row } from 'reactstrap';
import ReactQueryParams from "react-query-params";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

const days = ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי'];

export class ChooseDay extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
    }

    render() {

        let date = "";
        if(this.props.data && this.props.data.startDay) {
            date = this.props.data.startDay + " : " + this.props.data.endDay;
        }

        return(
            <Col md={12} xl={2} lg={6} sm={12} xs={12}>
                <style>
                    {`
                        .btn {
                        padding: 5px 18px;
                        }
                    `}
                </style>
                <Card>
                    <CardBody className="dashboard__health-chart-card">
                        <div className="card__title">
                            <h5 className="bold-text">{days[this.props.day-1]}</h5>
                        </div>
                        {/*<p className="dashboard__goal" style={{cursor: 'pointer'}}>Goal: 500 kKal</p>*/}
                        {date !== "" &&
                        <Button outline color='primary' onClick={() => this.props.chooseDate(this.props.day)}>{date}</Button>}
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.prize.status,
        //data: state.prize.data,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ChooseDay))